import React from 'react';

import Logo from '../authorizedState/header/logo';
import PasswordChangeForm from '../passwordChange/passwordChangeForm';

const PasswordChange = () => {
  return (
    <div className="password-reset">
      <div className="background" />
      <div className="container main-container">
        <Logo />
        <PasswordChangeForm />
      </div>
    </div>
  );
};

export default PasswordChange;
